import clsx from 'clsx'

import LinkButton from 'shared/ui/Button/LinkButton'
import { PATHS } from 'shared/utils/paths'

import styles from './MobileSubmenu.module.scss'

export const mobileSubmenuHeight = 36

interface MobileSubmenuProps {
  isRibbonOpen?: boolean
}
const MobileSubmenu = ({ isRibbonOpen }: MobileSubmenuProps) => {
  return (
    <div className={styles.tabletContent}>
      <nav
        className={clsx(styles.wrapper, {
          [styles.ribbonOpen]: isRibbonOpen
        })}
      >
        <LinkButton
          className={styles.link}
          href={PATHS.paymentMethods}
          size='small'
          variant='neutralText'
          fullWidth
        >
          Metody płatności
        </LinkButton>
        <hr className={styles.hr} />
        <LinkButton
          className={styles.link}
          href={PATHS.deliveryArea}
          size='small'
          variant='neutralText'
          fullWidth
        >
          O dostawie
        </LinkButton>
      </nav>
    </div>
  )
}

export default MobileSubmenu
